module.exports = __webpack_public_path__ + "v4assets/private_agent_icon.12649b8472e06625e71d8f849aaca0aa.png";